// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import '../src/plugins/index';
import '../src/common/navbar';

import '../src/common/share';
import WistiaModal from '../src/common/wistiaModal';

// We only load our job form JS on the pages the form is present
if (document.querySelectorAll("#job-form").length) {
  import("../src/pages/JobForm")
}

// We only load our home.js for index page
if (document.querySelectorAll(".promobi-home").length) {
  import("../src/pages/home")
}

// We only load our hero slider js for required page
if (document.querySelectorAll(".promobi-about, .women-in-promobi").length) {
  import("../src/common/hero-slider")
}

// load job filtering in /jobs and /careers pages
if (document.querySelector('#open-positions')) {
  import("../src/pages/filter")
}

// load employee benefits carousel in promobi culture page
if (document.querySelector('#employee-benefits-carousel')) {
  import('../src/pages/promobiCulture');
}
if (document.querySelector('.workspace-carousel')) {
  import('../src/common/workspace_slider')
}

import '../src/common/element_fade_in';

if (document.querySelector('.ten-years-in-business')) {
  import('../src/common/fireworks_video')
}

$(() => {
  const modalBtns = document.querySelectorAll('button[data-toggle="modal"]');
  if (!modalBtns) return

  Array.from(modalBtns, btn => {
    btn.addEventListener('click', () => {
        const target = btn.dataset.target;
        const modalBackdropEl = document.createElement('div')

        modalBackdropEl.classList.add('modal-backdrop')
        modalBackdropEl.classList.add('show')
        document.body.appendChild(modalBackdropEl)

        new WistiaModal(target).show()
    })
  })
})